import React from 'react';
import Modal from 'react-modal';
import InputWrapper from '../Wrappers/InputWrapper';
import withFormValidations from 'react-validator';

class ClaimNotifyModal extends React.Component {
  state = {
    email: this.props.email,
    error: false,
    valid: false
  }

  notifyClaim = e => {
    if (this.props.valid()) {
      this.props._merchant.notifyClaim(this.props.field('email').validations.val, this.state.error);
      this._closeModal(e);
    }
  }

  onChange = (input, value) => {
    this.props.onChange(input, value);
    this.setState({ valid: this.props.valid() });
    this.props.reset();
  }

  setError = bool => {
    this.setState({ error: bool });
  }

  // this is needed onMouseDown to prevent the input validations from firing onBlur
  _closeModal = e => {
    e.preventDefault();
    e.stopPropagation();
    this.props._search.setSearchTerm('', null);
    this.props._auth.toggleAuthenticationModal();
  }

  render() {
    const { auth, entities, field, search } = this.props;

    const merchant = entities
      .get('merchant')
      .find(m => m.vendor_id === search.get('selectedMerchantId'));

    const email = field('email');

    return <Modal
      isOpen={auth.get('modal')}
      closeTimeoutMS={150}
      className="modal-dialog"
      style={{
        overlay: {
          zIndex: 9999,
          backgroundColor: 'rgba(12, 10, 10, 0.75)'
        }
      }}
      contentLabel="Feature Notification">
        <div className="modal-content">
          <div>
            <button type="button" className="close" onMouseDown={this._closeModal}>
              <span aria-hidden="true">&times;</span>
              <span className="sr-only">Close</span>
            </button>
          </div>
          <div className="modal-body signin">
            <h3>{merchant.get('name')} has already been claimed.</h3>
            <p>We currently only allow one owner per business. We'll be updating Localvore soon to allow multiple owners.</p>
            <p>So, please send us your email and we'll contact you when you can use this feature.</p>
            <div className="form-group">
              <label htmlFor="claim-notify-modal-email-input">Email</label>
              <InputWrapper {...this.props}
                id="claim-notify-modal-email-input"
                input={email}
                onChange={this.onChange}
                valid={this.props.valid}
                type="email" />
            </div>
            <p>Do you think your business was claimed in error?</p>
            <p>
              <input type="radio" 
                style={{ display: 'inline', width: '5%' }} 
                onChange={() => this.setError(false)}
                checked={!this.state.error} /> No 

              <input type="radio" 
                style={{ display: 'inline', width: '5%', margin: '0 0 0 15px' }} 
                onChange={() => this.setError(true)}
                checked={this.state.error} /> Yes
            </p>

            {this.state.error && <p>
              You have indicated that you believe <strong>{merchant.get('name')}</strong> has been claimed in error.
              Submitting this form with your email will generate a support request to Localvore.
              A support representative will follow up with you.
            </p>}

            <button type="button" className={this.state.valid && 'valid'} onClick={this.notifyClaim}>Submit</button>
          </div>
        </div>
    </Modal>
  }
}

ClaimNotifyModal.defaultProps = {
  email: ''
};

export default  withFormValidations(ClaimNotifyModal, [{
  label: 'email',
  rules: [{
    rule: 'email',
    message: 'Invalid email address'
  }]
}])



// WEBPACK FOOTER //
// ./src/components/User/ClaimNotifyModal.js